import { countryData } from '@sunwebgroup/ui-components/uds'

const COUNTRIES_ALLOWING_LEADING_ZERO = ['it', 'ie']
const INTERNATIONAL_PREFIX = '00'
const LEADING_ZERO = '0'
const PLUS_PREFIX = '+'

interface PhoneNumberParts {
  prefix: string
  phoneNumber: string
}

function shouldRemoveLeadingZero(iso: string): boolean {
  if (!iso)
    return true
  return !COUNTRIES_ALLOWING_LEADING_ZERO.includes(iso.toLowerCase())
}

function removePrefixFromStart(phoneNumber: string, prefixToRemove: string): string {
  if (phoneNumber.startsWith(prefixToRemove)) {
    return phoneNumber.slice(prefixToRemove.length)
  }
  return phoneNumber
}

function parsePhoneNumber(value: string, currentIso: string): PhoneNumberParts | null {
  if (!value) {
    return null
  }

  let prefix: string | null = null
  let phoneNumber = value

  if (value.startsWith(INTERNATIONAL_PREFIX)) {
    const match2 = value.match(/^00(\d{2})(.*)/)
    const match3 = value.match(/^00(\d{3})(.*)/)

    if (match2 && isValidCountryCode(match2[1])) {
      prefix = match2[1]
      phoneNumber = match2[2]
    }
    else if (match3 && isValidCountryCode(match3[1])) {
      prefix = match3[1]
      phoneNumber = match3[2]
    }
    else {
      phoneNumber = value.replace(INTERNATIONAL_PREFIX, '')
    }
  }
  else if (value.startsWith(PLUS_PREFIX)) {
    const match2 = value.match(/^\+(\d{2})(.*)/)
    const match3 = value.match(/^\+(\d{3})(.*)/)

    if (match2 && isValidCountryCode(match2[1])) {
      prefix = match2[1]
      phoneNumber = match2[2]
    }
    else if (match3 && isValidCountryCode(match3[1])) {
      prefix = match3[1]
      phoneNumber = match3[2]
    }
    else {
      phoneNumber = value.replace(PLUS_PREFIX, '')
    }
  }

  if (shouldRemoveLeadingZero(currentIso)) {
    phoneNumber = removePrefixFromStart(phoneNumber, LEADING_ZERO)
  }

  return {
    prefix: prefix || '',
    phoneNumber: phoneNumber.trim(),
  }
}

function isValidCountryCode(code: string): boolean {
  return countryData.some(country => country.code === code)
}

export function formatPhoneNumberInput(
  value: string,
  selectedPrefix: string,
  iso: string,
): PhoneNumberParts {
  const parsed = parsePhoneNumber(value, iso)

  if (!parsed) {
    return { prefix: selectedPrefix, phoneNumber: '' }
  }

  const finalPrefix = parsed.prefix || selectedPrefix

  return {
    prefix: finalPrefix,
    phoneNumber: parsed.phoneNumber,
  }
}
